import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { ReactComponent as BlueRectangle } from "images/background/software-solution-graphic-blue.svg";
import { ReactComponent as RedRectangle } from "images/background/software-solution-graphic-red.svg";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import "./MerchantService.css";

const MerchantService = ({ data, header, oneSide, clickHandle }) => {
  return (
    <section className="merchantService">
      <div className="container">
        {data.length > 0 ?
          (
            data.map(item => {
              return (

                <div className={oneSide ? "row" : (item.id % 2 !== 0 ? "row" : "row flex-row-reverse")}>


                  <div
                    className={`col-lg-6 col-sm-12 ${item.class ? item.class : null
                      }`}
                  >
                    <div className="text-wrapper">
                      <div className="title">
                        <h2>{item.title}</h2>
                      </div>
                      {item.text && Array.isArray(item.text) ?
                        item.text.map((textItem, index) => <p key={index}>{textItem}</p>) :
                        <p>{item.text}</p>}

                      {item.link ? <div className="btn-wrapper">
                        <Link
                          className={
                            item.id % 2 !== 0 ? "green-button" : "accent-button"
                          }
                          to={item.link}
                        >
                          <FormattedMessage id={"learn_more"} />
                        </Link>
                      </div> : null}

                    </div>
                  </div>
                  {
                    item.img ? <div
                      className={`col-lg-6 col-sm-12 ${item.class ? item.class : null
                        }`}
                    >
                      <div className="image-wrapper">
                        <img src={item.img} alt="MerchantService" />
                      </div>
                    </div> : null
                  }

                  {/* <div
                    className={`col-lg-6 col-sm-12 ${item.class ? item.class : null
                      }`}
                  >
                    <div className="image-wrapper">
                      <img src={item.img} alt="MerchantService" />
                    </div>
                  </div> */}
                </div>
              );
            })
          ) : data.class ? (
            <div className={data.class}>
              <div className="row">
                <div
                  className={`col-lg-6 col-sm-12 ${data.class ? data.class : null
                    }`}
                >
                  <div className="text-wrapper">
                    <div className="title">
                      {data.id % 2 !== 0 ? <BlueRectangle /> : <RedRectangle />}
                      {/* <h2>Use case:</h2> */}
                      {/* modified code */}
                      <h2><FormattedMessage id={"use_case"}/></h2>
                      <h3>{data.title}</h3>
                    </div>
                    <div className="examples">
                      {/* <h4>Examples:</h4> */}
                      {/* modified code */}
                      <h4><FormattedMessage id={"examples"}/></h4>
                      {data.text.map((item) =>
                        <p key={item}>{item}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div
                className={`col-lg-6 col-sm-12 ${data.class ? data.class : null
                  }`}
              >
                <div className="text-wrapper">
                  <div className="title">
                    {data.id % 2 !== 0 ? <BlueRectangle /> : <RedRectangle />}
                    <h2>{data.title}</h2>
                  </div>
                  <p key={data.text}>{data.text}</p>
                  <div className="btn-wrapper">
                    <Link
                      className={
                        data.id % 2 !== 0 ? "green-button" : "accent-button"
                      }
                      to={data.link}
                      onClick={clickHandle}
                    >
                      <FormattedMessage id={"learn_more"} />
                    </Link>
                  </div>
                </div>
              </div>
              <div
                className={`col-lg-6 col-sm-12 ${data.class ? data.class : null}`}
              >
                <div className="image-wrapper">
                  <img src={data.img} alt="MerchantService" />
                </div>
              </div>
            </div>
          )}
      </div >
    </section >
  );
};

export default MerchantService;
